module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "setting"
  }, [_c('div', {
    staticClass: "setting__label"
  }, [_vm._v(_vm._s(_vm.$t(_vm.item.name)))]), _vm._v(" "), _c('div', {
    staticClass: "setting__option",
    attrs: {
      "id": "res-air-temp"
    }
  }, [_c('input', {
    attrs: {
      "id": "ref-set-flow",
      "type": "number",
      "min": "0",
      "max": "30",
      "step": ".1",
      "readonly": "readonly"
    },
    domProps: {
      "value": _vm._f("RounderOut")(_vm.item.value)
    },
    on: {
      "focus": function($event) {
        $event.preventDefault();
        $event.target.blur()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "setting__option setting__unit"
  }, [_vm._v(_vm._s(_vm.$t(_vm.converterType)))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-171d5ba4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SettingOuput.vue
// module id = 231
// module chunks = 0